import { createAsyncThunk } from '@reduxjs/toolkit';
import * as categoryApi from '../../utils/api/categoryApi';

// Fetch all categories
export const fetchCategories = createAsyncThunk(
  'category/fetchCategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await categoryApi.fetchCategories();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
